import { Box, Link, Typography } from "@mui/material";

import { PagePaper, SectionPaper } from "@/components/Paper";
import { PageTitle } from "@/components/Title";
import { KeyboardArrowLeft } from "@mui/icons-material";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import React from "react";
import { useFeatureFlags } from "@/configs/featureFlag";

import { useParams, Link as RouterLink } from "react-router-dom";
import { PublicLandPriceGetAPI } from "@/features/publicLandPrice/api/PublicLandPriceAPI";
import { LandPriceDetailsTable } from "@/features/publicLandPrice/components/LandPriceDetailsTable";

export const PublicLandPrice: React.FC = () => {
  const { mypageTop, publiclandpriceDetailView } = useFeatureFlags();

  const params = useParams();
  const id = parseInt(params.id as string);

  const publicLandPrice = PublicLandPriceGetAPI({ id });

  if (!publiclandpriceDetailView) {
    return null;
  }

  return (
    <PagePaper>
      {/* ページタイトル */}
      <Box sx={{ display: "flex", mb: 3 }}>
        <MonitorHeartIcon sx={{ mr: 1 }} fontSize="large" />
        <PageTitle>公示価格詳細</PageTitle>
      </Box>

      <SectionPaper>
        {publicLandPrice ? (
          <LandPriceDetailsTable landPrice={publicLandPrice} />
        ) : (
          "データが存在しません"
        )}
      </SectionPaper>

      {/* 戻る */}
      <Box sx={{ pt: 2 }}>
        <Link
          component={RouterLink}
          to={mypageTop ? "/mypage" : "/feed"}
          sx={{ display: "inline-block" }}
        >
          <Box sx={{ display: "flex" }}>
            <KeyboardArrowLeft />
            <Typography>
              {mypageTop ? "マイページに戻る" : "不動産の権利異動検索に戻る"}
            </Typography>
          </Box>
        </Link>
      </Box>
    </PagePaper>
  );
};
